<app-left-side-nav></app-left-side-nav>

<!-- page content area start-->
<div class="afterLoginPageContainer mt-0">
    <div class="mainContent" *ngIf="!isLoading">
        <div class="innovationsList" *ngIf="!isContestNotActive">
            <div class="head">
                <i class="fa-solid fa-arrow-left" (click)="goBack()"></i>

                <h1 class="font-weight-600 mt-2 text-center">Vote for Innovation!</h1>
                <p class="mb-0 text-center">Support the best agricultural innovations and<br>
                    help shape the future of farming.</p>
            </div>

            <p *ngIf="isVotingActive" class="fw-bold text-center mt-3 mb-0">You have voted {{ userContestVoteCount }}/{{ maxAllowedVoteCount }} entries</p>
            <p *ngIf="!isVotingActive" class="fw-bold text-center mt-3 mb-0">Voting is closed</p>

            <div class="list p-3" *ngIf="participantsList && participantsList.length > 0">
                <div class="single" *ngFor="let participant of participantsList">
                    <div class="imgout" (click)="openVideoDetails(participant)">
                        <img [src]="participant.thumbnail_url" alt="Innovation Image" class="thumb">
                        <img src="/assets/images/play-large.png" alt="play" class="playIcon">
                    </div>
                    <div class="disc px-2 pt-3 pb-2">
                        <h3 class="fw-bold mb-0">{{ participant?.title }}</h3>
                        <span class="vote-outer" *ngIf="isAuthenticated && isParticipantVoted(participant.id)"><i class="fa-regular fa-hand-pointer me-1"></i> Voted </span>
                    </div>
                </div>
            </div>
        </div>
        <ng-template #noContestTemplate>
            <div class="voting-inactive">
                <div class="d-flex align-items-center justify-content-center">
                    <i class="fa-solid fa-arrow-left text-black me-3 mb-1" (click)="goBack()"></i>
                    <h4>Contest is Currently Inactive</h4>
                </div>
            </div>
        </ng-template>
    </div>
</div> 